import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "options", "selected", "onSelected", "clampText", "disabled", "isDark", "dark", "className", "htmlProps"];
import { useRef, useState } from 'react';
import cn from 'classnames';
import { ArrowIosDown } from '@crehana/icons/outline';
import TextLink from "../Buttons/TextLink";
import MenuItem from "../Menu/MenuItem";
import Popper from "../Popper";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PopperMenu(_ref) {
  var label = _ref.label,
    options = _ref.options,
    selected = _ref.selected,
    onSelected = _ref.onSelected,
    clampText = _ref.clampText,
    disabled = _ref.disabled,
    isDark = _ref.isDark,
    dark = _ref.dark,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    htmlProps = _ref.htmlProps,
    popperMenuProps = _objectWithoutProperties(_ref, _excluded);
  var filtersRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    popperIsOpen = _useState2[0],
    setPopperIsOpen = _useState2[1];
  var togglePopper = function togglePopper() {
    setPopperIsOpen(!popperIsOpen);
  };
  var closePopper = function closePopper() {
    setPopperIsOpen(false);
  };
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread(_objectSpread({
    className: cn('flex items-center', className)
  }, popperMenuProps), htmlProps), {}, {
    children: [label && /*#__PURE__*/_jsx("span", {
      className: "pt-4 mr-8 font-label text-base-lighter",
      children: label
    }), /*#__PURE__*/_jsx(TextLink, {
      ref: filtersRef,
      onClick: togglePopper,
      label: selected.label,
      rightIcon: {
        component: ArrowIosDown,
        size: 16
      },
      disabled: disabled
    }), /*#__PURE__*/_jsx(Popper, {
      anchorRef: filtersRef,
      isVisible: popperIsOpen,
      dismissOnClickOutside: true,
      onDismiss: closePopper,
      isDark: isDark || dark,
      className: "flex flex-col",
      children: options.map(function (opt) {
        return /*#__PURE__*/_jsx(MenuItem, {
          onClick: function onClick() {
            if (onSelected) {
              onSelected(opt);
            }
            closePopper();
          },
          selected: selected && selected.value === opt.value,
          label: opt.label,
          clampText: clampText,
          isDark: isDark || dark
        }, "popper-menu-".concat(opt.label, "-").concat(opt.value));
      })
    })]
  }));
}
export default PopperMenu;